var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[_c('tr',[_c('td',[_c('span',{staticClass:"inline-block btn btn-default margin-right pull-left",class:["btn-sm"],attrs:{"id":"issuerow"},on:{"click":_vm.showIssueView}},[_vm._v(" "+_vm._s(_vm.issue.name)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }